<template>
    <div style="display:inline-block">
        <slot></slot>
    </div>
</template>
<script>
import XLSX from 'xlsx';//(http://blog.haoji.me/js-excel.html)
export default {
    methods:{
        download({bigHeaders,header,props,data,fileName,merges}){
			//bigHeaders--存在多级表头的情况
			//merges--需要合并的单元格范围
            let aoa=[]
			if(header){
				aoa=[header]
			}
			if(bigHeaders&&bigHeaders.length) {
				aoa = [
					...bigHeaders,
					...aoa
				]
			}
			data.forEach(item => {
				let col=[]
				props.forEach(key=>{
					// col.push(item[key]||'')
					col.push((item[key] === undefined || item[key] === null) ? '' : item[key])
				})
				aoa.push(col)
			});
			let sheet = XLSX.utils.aoa_to_sheet(aoa);
			if(merges && merges.length) {
				sheet['!merges'] = merges;
			}
			this.openDownloadDialog(this.sheet2blob(sheet), `${fileName||'对账数据'}.xlsx`);
        },
        sheet2blob(sheet, sheetName) {
			sheetName = sheetName || 'sheet1';
			var workbook = {
				SheetNames: [sheetName],
				Sheets: {}
			};
			workbook.Sheets[sheetName] = sheet;
			// 生成excel的配置项
			var wopts = {
				bookType: 'xlsx', // 要生成的文件类型
				bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
				type: 'binary'
			};
			var wbout = XLSX.write(workbook, wopts);
			var blob = new Blob([s2ab(wbout)], {type:"application/octet-stream"});
			// 字符串转ArrayBuffer
			function s2ab(s) {
				var buf = new ArrayBuffer(s.length);
				var view = new Uint8Array(buf);
				for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
				return buf;
			}
			return blob;
		},
		openDownloadDialog(url, saveName){
			if(typeof url == 'object' && url instanceof Blob)
			{
				url = URL.createObjectURL(url); // 创建blob地址
			}
			var aLink = document.createElement('a');
			aLink.href = url;
			aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			var event;
			if(window.MouseEvent) event = new MouseEvent('click');
			else
			{
				event = document.createEvent('MouseEvents');
				event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			}
			aLink.dispatchEvent(event);
		}
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/JsonToExcel.vue